"use strict";Object.defineProperty(exports, "__esModule", {value: true});
var _number = require('shared/services/number');

 const formatDisplayUnitCost = (total, units) =>
  exports.formatDisplayCost.call(void 0, total / units ); exports.formatDisplayUnitCost = formatDisplayUnitCost

 const formatDisplayCost = (x) => {
  const dollars = _number.round.call(void 0, x / 100, 0.01)
  return '$' + (Number.isInteger(dollars)
    ? dollars.toLocaleString()
    : dollars.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }))
}; exports.formatDisplayCost = formatDisplayCost
